import BaseCommand from "@/models/api/commands/BaseCommand";

export class RefundBookingItemCommand extends BaseCommand {
  CommandName = "RefundBookingItem";
  Command: string;
  constructor(sessionId: string, operationId: string, orderItemId: string) {
    super(sessionId, operationId);
    this.Command = orderItemId;
  }
}
